const ItemsTypes = {
  PERFORMANCE_TABLE_TO_COMPARE: 'PERFORMANCE_TABLE_TO_COMPARE'
}

export default ItemsTypes;